import { render, staticRenderFns } from "./ServidorFichaFinanceira.vue?vue&type=template&id=275694aa"
import script from "./ServidorFichaFinanceira.vue?vue&type=script&lang=js"
export * from "./ServidorFichaFinanceira.vue?vue&type=script&lang=js"
import style0 from "./ServidorFichaFinanceira.vue?vue&type=style&index=0&id=275694aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports